module.exports = __webpack_public_path__ + "star-blueprint-chocolate-ice-cream.56a82bb1889911913ff4.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/star-blueprint-chocolate-ice-cream.svg
// module id = ../../../../../src/assets/img/star-blueprint-chocolate-ice-cream.svg
// module chunks = main